<script>
	import * as animationData from '@assets/animations/loading.json';
	import Lottie from 'vue-lottie';

	export default {
		components: {
			Lottie
		},
		data() {
			return {
				defaultOptions: {
					loop: true,
					autoplay: true,
					animationData: animationData.default
				},
				animationSpeed: 1,
				showLoadingMessage: false,
				loadingMessage: "Please Wait..."
			};
		},
		created() {
			setTimeout(() => {
				this.showLoadingMessage = true;
				setTimeout(() => {
					this.loadingMessage = "Your trusted HR partner. We're almost there...";
				}, 8000)
			}, 3000)
		},
		methods: {
			handleAnimation(anim) {
				this.anim = anim;
			}
		}
	};
</script>

<template>
	<v-container class="fill-height loading-container" fluid>
			<v-layout align-center justify-center>
				<v-flex xs12 sm8 md6>
					<v-flex class="text-center">
						<img style="height: 43px" src="@/assets/yhrs_logo.png" alt="Your HR System" />
						<Lottie :options="defaultOptions" :height="110" :width="110" @animCreated="handleAnimation" />

						<h2 v-if="showLoadingMessage">{{ loadingMessage }}</h2>
				
					</v-flex>
				</v-flex>
			</v-layout>
		</v-container>
</template>

<style scoped>
    .loading-container {
        background-color: #fafafa;
    }
</style>